module.exports = __webpack_public_path__ + "img/organizations.f9a05473.svg";